import { Chip } from '@mui/material';

export const reassignLeadTableHeader = [
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 200,
  },
  {
    field: 'mob',
    headerName: 'Mobile',
    width: 150,
  },
  {
    field: 'owner',
    headerName: 'Owner',
    width: 180,
  },
  {
    field: 'ownerStatus',
    headerName: 'Owner Status',
    width: 180,
    renderCell: ({ value }) => (
      <Chip
        label={Boolean(value) ? 'Active' : 'Inactive'}
        variant="outlined"
        color={Boolean(value) ? 'success' : 'error'}
      />
    ),
  },
];
